import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  EntriesState,
  PaginationState,
  SearchPageResultState,
  SearchState,
} from '../../../../core/features/store/base-feature-state';
import { Pagination, SoldTo } from '../../../../core/model';
import { PyStateUtils } from '../../../../core/state';
import { AvailableSearchParamsState, AvailableState, SoldToState, StateWithSoldTo } from '../sold-to-state';
import { getSoldToState } from './feature.selector';

export const getAvailableSoldTosState: MemoizedSelector<StateWithSoldTo, AvailableState> = createSelector(
  getSoldToState,
  (state: SoldToState) => state && state.available
);

export const getAvailableSearchResultEntities: MemoizedSelector<StateWithSoldTo, EntriesState<SoldTo> | undefined> =
  createSelector(getAvailableSoldTosState, (state: AvailableState) => (state && state.entities) || undefined);

export const getAvailableSearchParamsSelector: MemoizedSelector<StateWithSoldTo, AvailableSearchParamsState> = createSelector(
  getAvailableSoldTosState,
  (state: AvailableState) => (state && state.searchParams) || undefined
);

export const getAvailableSearchSelector: MemoizedSelector<StateWithSoldTo, SearchState<SearchPageResultState> | undefined> =
  createSelector(getAvailableSoldTosState, (state: AvailableState) => (state && state.search) || undefined);

export const getAvailableSearchPaginationStateSelector: MemoizedSelector<
  StateWithSoldTo,
  PaginationState<SearchPageResultState> | undefined
> = createSelector(
  getAvailableSearchSelector,
  getAvailableSearchParamsSelector,
  (state: SearchState<SearchPageResultState>, searchParams: AvailableSearchParamsState) => {
    return (searchParams && state && state[searchParams.key]) || undefined;
  }
);

export const getAvailableSearchPageResultsSelector: MemoizedSelector<
  StateWithSoldTo,
  StateUtils.LoaderState<SearchPageResultState>
> = createSelector(
  getAvailableSearchParamsSelector,
  getAvailableSearchPaginationStateSelector,
  (queryParams: AvailableSearchParamsState, paginationState: PaginationState<SearchPageResultState>) => {
    return (
      (queryParams && paginationState && paginationState.pages && paginationState.pages[queryParams.page]) ||
      PyStateUtils.initialLoaderState
    );
  }
);

export const getAvailableSearchPaginationSelector: MemoizedSelector<StateWithSoldTo, Pagination | undefined> = createSelector(
  getAvailableSearchPaginationStateSelector,
  (state) => (state && state.pagination) || undefined
);

export const getAvailableSearchResultEntries: MemoizedSelectorWithProps<StateWithSoldTo, any, SoldTo[] | undefined> =
  createSelector(getAvailableSearchResultEntities, (entries: EntriesState<SoldTo>, props) => {
    return (props.keys && entries && props.keys.map((i) => entries[i])) || undefined;
  });
